// react-router's own history implementation, not the standalone `history` package. They are not
// interchangeable: `HistoryRouter` calls `createURL`/`encodeLocation`, which `history@5` does not
// provide, and pairing react-router 5 with `history@5` is what left `useLocation()` returning the
// raw `{ action, location }` listener payload after every in-app navigation. One implementation,
// owned by the router, removes that skew class — see `historySync.shared.test.tsx`.
//
// `v5Compat: true` is required, not cosmetic: without it `push`/`replace` update the URL but never
// notify the listener, so the FSM would navigate and the router would never re-render. It is the
// flag react-router's own `BrowserRouter` passes.
import { UNSAFE_createBrowserHistory as createBrowserHistory } from 'react-router-dom'

export default createBrowserHistory({ v5Compat: true })
